export const UPLOAD_NOTICE_RESULTS_SUCCESS = 'UPLOAD_NOTICE_RESULTS_SUCCESS';

export const uploadNoticeResultsSuccess = () => ({
    type: UPLOAD_NOTICE_RESULTS_SUCCESS,
});
